module.exports = __webpack_public_path__ + "static/media/7P.e2723b55.svg";